import { Grid } from "@material-ui/core";
import * as React from "react";
import VisualiserFonctionnalite from "../VisualiserFonctionnalite";
import Fonctionnalite from "./Fonctionnalite";
import GroupeFonctionnalite from "./GroupeFonctionnalite";
import Module from "./Module";
import SousModule from "./SousModule";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import {
  setFilterFonctionnalites,
  setFonctionnalites,
} from "./Fonctionnalite/fonctionnaliteSlice";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { setCreer } from "../../store/appSlice";

export interface ISearchBarProps {
  filterFonction: any;
  search:any;
  setSearch:any;
}

const SearchBar = (props: ISearchBarProps) => {
  //props
  const { filterFonction,search, setSearch } = props;

  //redux
  const dispatch = useDispatch();
  const { creer } = useSelector((state: IReduxState) => state.application);

  //hooks
  const theme = useTheme();
  const endesssousDeLg = useMediaQuery(theme.breakpoints.down("lg"));

  React.useEffect(() => {
    filterFonction();
  }, [search]);

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="center"
        spacing={2}
        style={{
          background: "aliceblue",
          marginBottom: 10,
          height: "9vh",
          padding: 10,
        }}
      >
        <Grid item xs={12} md={6}>
          <Button
            startIcon={<AddIcon />}
            variant={creer ? "contained" : "outlined"}
            onClick={() => dispatch(setCreer(true))}
            style={{ marginRight: 5 }}
          >
            Créer
          </Button>

          <Button
            startIcon={<VisibilityIcon />}
            variant={!creer ? "contained" : "outlined"}
            onClick={() => dispatch(setCreer(false))}
          >
            Visualiser
          </Button>
        </Grid>

        <Grid item xs={12} md={6}>
          {!creer && (
            <TextField
              style={{ marginTop: endesssousDeLg ? 15 : 0 }}
              size="small"
              fullWidth
              label="Rechercher..."
              onChange={(e) => setSearch(e.target.value)}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default SearchBar;
